import React from 'react';
import sliderImg from '../../../assets/img/slider.jpg';
import headerVideoET from '../../../assets/video/header-et.mp4';

const Slider = () => {
  return (
    <div
      className="slider"
      dangerouslySetInnerHTML={{
        __html: `
        <video
          loop
          muted
          autoplay
          playsinline
          preload="metadata"
        >
        <source src="${headerVideoET}" type="video/mp4" />
        </video>`
      }}
    />
  );
};

export default Slider;
